<template>
    <div :class="['v-alert find', DB.cssWidth]">
        <header><p>Find</p><div class="x" @click="exit"></div></header>
        <div class="search-input">
            <input :placeholder="DB.placeholder || 'Search'" @keyup="search($event,100)"/>
        </div>
        <div v-for="item in items" class="d-grid search-item" :style="{ 'grid-template-columns': DB.grid }">
            <p @click="show(item)" class="ellip" v-for="field in DB.fields">{{ item[field] }}</p>
        </div>
    </div>
</template>

<script>

import WebSoc from '../utils/WebSoc.js'
import prettyPhone from '../utils/prettyPhone.js';

export default {
    name: 'Find',
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    data () {
        return {
            items: [],
            db: {
                members: {
                    cssWidth: 'w-600',
                    grid: '1fr 1fr 1fr',
                    DB: '-customers',
                    page: 'members',
                    placeholder: 'Search by Name / Email / Phone',
                    fields: ['name','email','phone'],
                },
                cards: {
                    cssWidth: '',
                    grid: '1fr',
                    DB: 'cards',
                    placeholder: 'Search by Card title',
                    fields: ['title']
                }
            }
        }
    },
    created () {
        this.DB = this.db[this.$route.params.db];
        if ( this.DB.DB == '-customers') this.DB.DB = this.client_id+this.DB.DB;
        this.DB.project = this.DB.fields.reduce((p,f) => { p[f] = 1 ; return p },{})
    },
    mounted () {
        this.search();
        this.$el.querySelector('input').focus();
    },
    methods: {
        exit () {
            console.log('exit');
            this.$router.push('/')
        },
        show ( item ) {
            if ( this.DB.DB == 'cards' ) {
                this.$router.push('/view-card/'+item._id);
                return console.log('cards',item);
            }
            this.$router.push('/'+this.DB.page+'/edit/'+item._id);
        },
        search ( e = {}, delay = 0 ) {
            if ( [37,38,39,40].indexOf(e.keyCode) > -1 ) return;
            if ( e.keyCode == 27 ) return this.exit();
            clearTimeout(this._search);
            this._search = setTimeout(() => {
                var value = e.target ? e.target.value : '';
                var db = this.DB.DB;
                var project = this.DB.project;
                var find = { $or: this.DB.fields.map(f => { return { [f]: { $regex: value, $options: 'i' } } }) }
                WebSoc.SEND('search',{ DB: db, find, project, limit: 10 },items => {
                    if ( project.phone ) {
                        items.forEach(i => {
                            i.phone = prettyPhone(i.phone);
                        })
                    }
                    this.items = items;
                })
            },parseInt(delay));
        }
    }
}    
</script>

<style lang="scss">
.d-grid {
    display: grid;
} 
.search-input {
    float: left;
    width: 100%;
    border-bottom: 1px solid #c0c0c0;
    input { margin: 5px; width: calc(100% - 25px) }
}
.search-item {
    width: calc(100% - 10px);
    padding: 5px;
    &:nth-child(odd) {
        background-color: rgba(200,200,200,0.3);
    }
    > p:nth-child(1) {
        color: blue;
        text-decoration: underline;
    }
}
</style>